// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.tienda {
  background-color: #f4f4f4;
  min-height: calc(100vh - 120px);
  padding: 20px 0 40px;
}

.tienda-header-bar {
  background-color: #f4f4f4;
  padding: 6px 20px 10px;
  max-width: 1440px;
  margin: 0 auto;
}
@media (max-width: 768px) {
  .tienda-header-bar {
    padding: 4px 12px 6px;
  }
}

.breadcrumb-nav {
  padding: 2px 0 6px;
}
.breadcrumb-nav .breadcrumb-item {
  font-size: 0.88rem;
  color: #4b5563;
}
.breadcrumb-nav .breadcrumb-item.active {
  color: #111827;
  font-weight: 600;
}
@media (max-width: 768px) {
  .breadcrumb-nav .breadcrumb-item {
    font-size: 0.78rem;
  }
}

.sort-box {
  display: flex;
  align-items: center;
  gap: 8px;
}
.sort-box .sort-label {
  font-size: 0.88rem;
  color: #4b5563;
  font-weight: 600;
  margin: 0;
  white-space: nowrap;
}
@media (max-width: 768px) {
  .sort-box .sort-label {
    font-size: 0.78rem;
  }
}
.sort-box .sort-select {
  height: 40px;
  width: 155px;
  border-radius: 10px;
  border: 1px solid #d1d5db;
  background-color: #ffffff;
  font-size: 0.86rem;
  font-weight: 500;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}
.sort-box .sort-select:focus {
  border-color: #dc2626;
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.12);
}
@media (max-width: 768px) {
  .sort-box .sort-select {
    height: 36px;
    width: 135px;
    font-size: 0.78rem;
    padding: 4px 8px;
  }
}

.tienda-content {
  display: flex;
  flex-direction: row;
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 20px;
  gap: 16px;
}
@media (max-width: 900px) {
  .tienda-content {
    flex-direction: column;
    padding: 0 12px;
    gap: 12px;
  }
}

.filtro {
  width: 250px;
  min-width: 230px;
  flex-shrink: 0;
}
@media (max-width: 900px) {
  .filtro {
    width: 100%;
    min-width: 100%;
  }
}
.filtro .accordion-item {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.03);
}
.filtro .btn-filtro {
  background-color: #ffffff;
  border: none;
  padding: 10px 16px;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #1f2937;
}
.filtro .btn-filtro:focus {
  box-shadow: none;
}
@media (max-width: 768px) {
  .filtro .btn-filtro {
    padding: 8px 12px;
    font-size: 0.88rem;
  }
}
.filtro .btn-limpiar-filtros {
  width: auto;
  min-width: 130px;
  max-width: 170px;
  padding: 6px 14px;
  font-size: 0.86rem;
  border-radius: 8px;
  margin: 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.filtro .accordion-content {
  padding: 8px 16px 16px;
  width: 100%;
}
@media (max-width: 768px) {
  .filtro .accordion-content {
    padding: 6px 12px 12px;
  }
}
.filtro .form-select {
  border-radius: 8px;
  border: 1px solid #d1d5db;
  font-size: 0.88rem;
  padding: 8px 12px;
}
.filtro .form-select:focus {
  border-color: #dc2626;
  box-shadow: 0 0 0 2px rgba(220, 38, 38, 0.12);
}
@media (max-width: 768px) {
  .filtro .form-select {
    font-size: 0.82rem;
    padding: 6px 10px;
  }
}

.showroom-wrapper {
  flex: 1;
  min-width: 0;
}

.filter-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background-color: #1f2937;
  color: #ffffff;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 0.82rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
}
.filter-chip i {
  font-size: 1rem;
}
.filter-chip:hover {
  background-color: #dc2626;
  transform: translateY(-1px);
}
@media (max-width: 768px) {
  .filter-chip {
    font-size: 0.74rem;
    padding: 3px 8px;
  }
}

.tienda .showroom {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  background-color: transparent;
  padding: 0;
}

@media (min-width: 1440px) {
  .tienda .showroom {
    grid-template-columns: repeat(4, 1fr);
    gap: 18px;
  }
}
@media (max-width: 1100px) {
  .tienda .showroom {
    grid-template-columns: repeat(3, 1fr);
    gap: 14px;
  }
}
@media (max-width: 900px) {
  .tienda .showroom {
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
  }
}
/* Estilos de Card para Desktop */
.showroom .card {
  width: 100%;
  height: 100%;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.showroom .card:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
}
.showroom .card .img-container {
  position: relative;
  width: 100%;
  height: 200px;
  padding: 12px;
  background: #fafafa;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.showroom .card .img-container .img-publica {
  max-height: 100%;
  max-width: 100%;
  object-fit: contain;
  transition: transform 0.25s ease;
}
.showroom .card .img-container:hover .img-publica {
  transform: scale(1.04);
}
.showroom .card .flag-mayorista {
  position: absolute;
  top: 0;
  left: 0;
  height: 58px;
  z-index: 2;
  pointer-events: none;
}
.showroom .card .body {
  padding: 14px 12px 12px;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;
}
.showroom .card .body .name {
  min-height: 42px;
  height: 42px;
  margin-bottom: 6px;
}
.showroom .card .body .name p {
  font-size: 0.88rem;
  font-weight: 600;
  line-height: 1.3;
  color: #1f2937;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.showroom .card .body .price {
  margin: 2px 0 8px;
}
.showroom .card .body .price .card-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: #dc2626;
  margin: 0;
}
.showroom .card .body .options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 8px;
  border-top: 1px solid #f3f4f6;
}
.showroom .card .body .options .vermas {
  font-size: 0.84rem;
  font-weight: 600;
  color: #2563eb;
  margin: 0;
}
.showroom .card .body .options .vermas:hover {
  text-decoration: underline;
}
.showroom .card .body .options .icon {
  font-size: 1.45rem;
  color: #1f2937;
  cursor: pointer;
  transition: color 0.15s ease, transform 0.15s ease;
}
.showroom .card .body .options .icon:hover {
  color: #dc2626;
  transform: scale(1.15);
}
.showroom .card .body .options .icon.text-muted {
  color: #9ca3af !important;
  cursor: not-allowed;
}
.showroom .card .body .options .icon.text-muted:hover {
  transform: none;
}

/* Mobile Overrides */
@media (max-width: 640px) {
  .tienda {
    padding: 10px 0 24px;
  }
  .tienda-header-bar {
    padding: 6px 10px 4px;
  }
  .tienda-content {
    padding: 0 10px;
    gap: 10px;
  }
  .tienda .showroom {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    width: 100%;
  }
  .showroom .card {
    border-radius: 12px;
  }
  .showroom .card .img-container {
    height: 160px;
    padding: 8px;
  }
  .showroom .card .flag-mayorista {
    height: 52px;
  }
  .showroom .card .body {
    padding: 10px 8px 8px;
  }
  .showroom .card .body .name {
    height: 36px;
    min-height: 36px;
    margin-bottom: 4px;
  }
  .showroom .card .body .name p {
    font-size: 0.82rem;
    line-height: 1.25;
  }
  .showroom .card .body .price {
    margin: 2px 0 6px;
  }
  .showroom .card .body .price .card-title {
    font-size: 1.02rem;
  }
  .showroom .card .body .options {
    padding-top: 4px;
  }
  .showroom .card .body .options .vermas {
    font-size: 0.78rem;
  }
  .showroom .card .body .options .icon {
    font-size: 1.35rem;
  }
}
.empty-state {
  background-color: #ffffff;
  border-radius: 16px;
  padding: 3.5rem 1.5rem;
  border: 1px dashed #d1d5db;
}
@media (max-width: 768px) {
  .empty-state {
    padding: 2rem 1rem;
  }
}

.cart-modal {
  position: fixed;
  z-index: 1050;
  top: 130px;
  right: 25px;
  animation: slideInRight 0.3s ease-out;
}
@media (max-width: 768px) {
  .cart-modal {
    top: 90px;
    right: 12px;
    left: 12px;
  }
}
.cart-modal .alert {
  border-radius: 12px;
  font-weight: 500;
}

@keyframes slideInRight {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
.pointer {
  cursor: pointer;
}

.switch {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 22px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #d1d5db;
  transition: 0.3s;
  border-radius: 22px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.3s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #16a34a;
}

input:checked + .slider:before {
  transform: translateX(22px);
}

/* ==========================================================================
   Paginación Moderna & Responsive
   ========================================================================== */
.custom-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
}
.custom-pagination .pagination-list {
  display: flex;
  align-items: center;
  list-style: none;
  padding: 6px 8px;
  margin: 0;
  gap: 8px;
  background: #ffffff;
  border-radius: 14px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}
@media (max-width: 576px) {
  .custom-pagination .pagination-list {
    gap: 6px;
    padding: 4px 6px;
    border-radius: 12px;
  }
}
.custom-pagination .pagination-item {
  display: flex;
  align-items: center;
}
.custom-pagination .pagination-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 38px;
  padding: 0 16px;
  font-size: 0.88rem;
  font-weight: 600;
  color: #374151;
  background-color: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease-in-out;
  -webkit-user-select: none;
          user-select: none;
}
.custom-pagination .pagination-btn i {
  font-size: 1.25rem;
  line-height: 1;
  display: inline-flex;
  align-items: center;
}
.custom-pagination .pagination-btn:hover:not(:disabled) {
  background-color: #dc2626;
  border-color: #dc2626;
  color: #ffffff;
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(220, 38, 38, 0.2);
}
.custom-pagination .pagination-btn:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 1px 3px rgba(220, 38, 38, 0.2);
}
.custom-pagination .pagination-btn:focus-visible {
  outline: 2px solid #dc2626;
  outline-offset: 2px;
}
.custom-pagination .pagination-btn:disabled {
  background-color: #f3f4f6;
  border-color: #e5e7eb;
  color: #9ca3af;
  cursor: not-allowed;
  opacity: 0.55;
  box-shadow: none;
  pointer-events: none;
}
@media (max-width: 576px) {
  .custom-pagination .pagination-btn {
    height: 36px;
    width: 36px;
    padding: 0;
    border-radius: 8px;
  }
  .custom-pagination .pagination-btn .btn-text {
    display: none;
  }
  .custom-pagination .pagination-btn i {
    font-size: 1.35rem;
  }
}
.custom-pagination .pagination-info-item {
  display: flex;
  align-items: center;
}
.custom-pagination .pagination-indicator {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 38px;
  padding: 0 12px;
  font-size: 0.88rem;
  font-weight: 500;
  color: #4b5563;
  white-space: nowrap;
}
.custom-pagination .pagination-indicator .indicator-text {
  color: #6b7280;
}
.custom-pagination .pagination-indicator .indicator-current {
  font-weight: 700;
  color: #dc2626;
}
.custom-pagination .pagination-indicator .indicator-separator {
  color: #9ca3af;
}
.custom-pagination .pagination-indicator .indicator-total {
  font-weight: 600;
  color: #1f2937;
}
@media (max-width: 576px) {
  .custom-pagination .pagination-indicator {
    height: 36px;
    padding: 0 6px;
    font-size: 0.82rem;
  }
  .custom-pagination .pagination-indicator .indicator-text {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./../../Universo%20Tunning/ecommerce/src/app/pages/tienda/tienda.component.scss","webpack://./src/app/pages/tienda/tienda.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;EACE,yBAAA;EACA,+BAAA;EACA,oBAAA;ADEF;;ACCA;EACE,yBAAA;EACA,sBAAA;EACA,iBAAA;EACA,cAAA;ADEF;ACAE;EANF;IAOI,qBAAA;EDGF;AACF;;ACAA;EACE,kBAAA;ADGF;ACDE;EACE,kBAAA;EACA,cAAA;ADGJ;ACDI;EACE,cAAA;EACA,gBAAA;ADGN;ACAI;EATF;IAUI,kBAAA;EDGJ;AACF;;ACCA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;ADEF;ACAE;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;ADEJ;ACAI;EAPF;IAQI,kBAAA;EDGJ;AACF;ACAE;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yCAAA;ADEJ;ACAI;EACE,qBAAA;EACA,6CAAA;ADEN;ACCI;EAhBF;IAiBI,YAAA;IACA,YAAA;IACA,kBAAA;IACA,gBAAA;EDEJ;AACF;;ACEA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,SAAA;ADCF;ACCE;EARF;IASI,sBAAA;IACA,eAAA;IACA,SAAA;EDEF;AACF;;ACCA;EACE,YAAA;EACA,gBAAA;EACA,cAAA;ADEF;ACAE;EALF;IAMI,WAAA;IACA,eAAA;EDGF;AACF;ACDE;EACE,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,yCAAA;ADGJ;ACAE;EACE,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,cAAA;ADEJ;ACAI;EACE,gBAAA;ADEN;ACCI;EAdF;IAeI,iBAAA;IACA,kBAAA;EDEJ;AACF;ACCE;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;ADCJ;ACEE;EACE,sBAAA;EACA,WAAA;ADAJ;ACEI;EAJF;IAKI,sBAAA;EDCJ;AACF;ACEE;EACE,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;ADAJ;ACEI;EACE,qBAAA;EACA,6CAAA;ADAN;ACGI;EAXF;IAYI,kBAAA;IACA,iBAAA;EDAJ;AACF;;ACIA;EACE,OAAA;EACA,YAAA;ADDF;;ACIA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;ADDF;ACGE;EACE,eAAA;ADDJ;ACIE;EACE,yBAAA;EACA,2BAAA;ADFJ;ACKE;EAtBF;IAuBI,kBAAA;IACA,gBAAA;EDFF;AACF;;ACKA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,6BAAA;EACA,UAAA;ADFF;;ACKA;EACE;IACE,qCAAA;IACA,SAAA;EDFF;AACF;ACKA;EACE;IACE,qCAAA;IACA,SAAA;EDHF;AACF;ACMA;EACE;IACE,qCAAA;IACA,SAAA;EDJF;AACF;ACOA,iCAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,aAAA;EACA,sBAAA;EACA,qDAAA;ADLF;ACOE;EACE,2BAAA;EACA,0CAAA;ADLJ;ACQE;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;ADNJ;ACQI;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,gCAAA;ADNN;ACSI;EACE,sBAAA;ADPN;ACWE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;ADTJ;ACYE;EACE,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,OAAA;EACA,8BAAA;ADVJ;ACYI;EACE,gBAAA;EACA,YAAA;EACA,kBAAA;ADVN;ACYM;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;ADVR;ACcI;EACE,iBAAA;ADZN;ACcM;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;ADZR;ACgBI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,6BAAA;ADdN;ACgBM;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;ADdR;ACgBQ;EACE,0BAAA;ADdV;ACkBM;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kDAAA;ADhBR;ACkBQ;EACE,cAAA;EACA,sBAAA;ADhBV;ACmBQ;EACE,yBAAA;EACA,mBAAA;ADjBV;ACkBU;EACE,eAAA;ADhBZ;;ACwBA,qBAAA;AACA;EACE;IACE,oBAAA;EDrBF;ECwBA;IACE,qBAAA;EDtBF;ECyBA;IACE,eAAA;IACA,SAAA;EDvBF;EC0BA;IACE,qCAAA;IACA,SAAA;IACA,WAAA;EDxBF;EC2BA;IACE,mBAAA;EDzBF;EC2BE;IACE,aAAA;IACA,YAAA;EDzBJ;EC4BE;IACE,YAAA;ED1BJ;EC6BE;IACE,qBAAA;ED3BJ;EC6BI;IACE,YAAA;IACA,gBAAA;IACA,kBAAA;ED3BN;EC6BM;IACE,kBAAA;IACA,iBAAA;ED3BR;EC+BI;IACE,iBAAA;ED7BN;EC+BM;IACE,kBAAA;ED7BR;ECiCI;IACE,gBAAA;ED/BN;ECiCM;IACE,kBAAA;ED/BR;ECkCM;IACE,kBAAA;EDhCR;AACF;ACsCA;EACE,yBAAA;EACA,mBAAA;EACA,sBAAA;EACA,0BAAA;ADpCF;ACsCE;EANF;IAOI,kBAAA;EDnCF;AACF;;ACsCA;EACE,eAAA;EACA,aAAA;EACA,UAAA;EACA,WAAA;EACA,qCAAA;ADnCF;ACqCE;EAPF;IAQI,SAAA;IACA,WAAA;IACA,UAAA;EDlCF;AACF;ACoCE;EACE,mBAAA;EACA,gBAAA;ADlCJ;;ACsCA;EACE;IACE,2BAAA;IACA,UAAA;EDnCF;ECqCA;IACE,wBAAA;IACA,UAAA;EDnCF;AACF;ACsCA;EACE,eAAA;ADpCF;;ACuCA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;ADpCF;;ACuCA;EACE,UAAA;EACA,QAAA;EACA,SAAA;ADpCF;;ACuCA;EACE,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;ADpCF;;ACuCA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;ADpCF;;ACuCA;EACE,yBAAA;ADpCF;;ACuCA;EACE,2BAAA;ADpCF;;ACuCA;;+EAAA;AAGA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;ADpCF;ACsCE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,QAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yCAAA;ADpCJ;ACsCI;EAZF;IAaI,QAAA;IACA,gBAAA;IACA,mBAAA;EDnCJ;AACF;ACsCE;EACE,aAAA;EACA,mBAAA;ADpCJ;ACuCE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,gCAAA;EACA,yBAAA;UAAA,iBAAA;ADrCJ;ACuCI;EACE,kBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;ADrCN;ACwCI;EACE,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,2BAAA;EACA,6CAAA;ADtCN;ACyCI;EACE,wBAAA;EACA,4CAAA;ADvCN;AC0CI;EACE,0BAAA;EACA,mBAAA;ADxCN;AC2CI;EACE,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,oBAAA;ADzCN;AC4CI;EArDF;IAsDI,YAAA;IACA,WAAA;IACA,UAAA;IACA,kBAAA;EDzCJ;EC2CI;IACE,aAAA;EDzCN;EC4CI;IACE,kBAAA;ED1CN;AACF;AC8CE;EACE,aAAA;EACA,mBAAA;AD5CJ;AC+CE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AD7CJ;AC+CI;EACE,cAAA;AD7CN;ACgDI;EACE,gBAAA;EACA,cAAA;AD9CN;ACiDI;EACE,cAAA;AD/CN;ACkDI;EACE,gBAAA;EACA,cAAA;ADhDN;ACmDI;EA9BF;IA+BI,YAAA;IACA,cAAA;IACA,kBAAA;EDhDJ;ECkDI;IACE,aAAA;EDhDN;AACF","sourcesContent":["@charset \"UTF-8\";\n.tienda {\n  background-color: #f4f4f4;\n  min-height: calc(100vh - 120px);\n  padding: 20px 0 40px;\n}\n\n.tienda-header-bar {\n  background-color: #f4f4f4;\n  padding: 6px 20px 10px;\n  max-width: 1440px;\n  margin: 0 auto;\n}\n@media (max-width: 768px) {\n  .tienda-header-bar {\n    padding: 4px 12px 6px;\n  }\n}\n\n.breadcrumb-nav {\n  padding: 2px 0 6px;\n}\n.breadcrumb-nav .breadcrumb-item {\n  font-size: 0.88rem;\n  color: #4b5563;\n}\n.breadcrumb-nav .breadcrumb-item.active {\n  color: #111827;\n  font-weight: 600;\n}\n@media (max-width: 768px) {\n  .breadcrumb-nav .breadcrumb-item {\n    font-size: 0.78rem;\n  }\n}\n\n.sort-box {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.sort-box .sort-label {\n  font-size: 0.88rem;\n  color: #4b5563;\n  font-weight: 600;\n  margin: 0;\n  white-space: nowrap;\n}\n@media (max-width: 768px) {\n  .sort-box .sort-label {\n    font-size: 0.78rem;\n  }\n}\n.sort-box .sort-select {\n  height: 40px;\n  width: 155px;\n  border-radius: 10px;\n  border: 1px solid #d1d5db;\n  background-color: #ffffff;\n  font-size: 0.86rem;\n  font-weight: 500;\n  cursor: pointer;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n}\n.sort-box .sort-select:focus {\n  border-color: #dc2626;\n  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.12);\n}\n@media (max-width: 768px) {\n  .sort-box .sort-select {\n    height: 36px;\n    width: 135px;\n    font-size: 0.78rem;\n    padding: 4px 8px;\n  }\n}\n\n.tienda-content {\n  display: flex;\n  flex-direction: row;\n  max-width: 1440px;\n  margin: 0 auto;\n  padding: 0 20px;\n  gap: 16px;\n}\n@media (max-width: 900px) {\n  .tienda-content {\n    flex-direction: column;\n    padding: 0 12px;\n    gap: 12px;\n  }\n}\n\n.filtro {\n  width: 250px;\n  min-width: 230px;\n  flex-shrink: 0;\n}\n@media (max-width: 900px) {\n  .filtro {\n    width: 100%;\n    min-width: 100%;\n  }\n}\n.filtro .accordion-item {\n  border-radius: 12px;\n  overflow: hidden;\n  border: 1px solid #e5e7eb;\n  background: #ffffff;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.03);\n}\n.filtro .btn-filtro {\n  background-color: #ffffff;\n  border: none;\n  padding: 10px 16px;\n  font-weight: 600;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: #1f2937;\n}\n.filtro .btn-filtro:focus {\n  box-shadow: none;\n}\n@media (max-width: 768px) {\n  .filtro .btn-filtro {\n    padding: 8px 12px;\n    font-size: 0.88rem;\n  }\n}\n.filtro .btn-limpiar-filtros {\n  width: auto;\n  min-width: 130px;\n  max-width: 170px;\n  padding: 6px 14px;\n  font-size: 0.86rem;\n  border-radius: 8px;\n  margin: 0 auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n.filtro .accordion-content {\n  padding: 8px 16px 16px;\n  width: 100%;\n}\n@media (max-width: 768px) {\n  .filtro .accordion-content {\n    padding: 6px 12px 12px;\n  }\n}\n.filtro .form-select {\n  border-radius: 8px;\n  border: 1px solid #d1d5db;\n  font-size: 0.88rem;\n  padding: 8px 12px;\n}\n.filtro .form-select:focus {\n  border-color: #dc2626;\n  box-shadow: 0 0 0 2px rgba(220, 38, 38, 0.12);\n}\n@media (max-width: 768px) {\n  .filtro .form-select {\n    font-size: 0.82rem;\n    padding: 6px 10px;\n  }\n}\n\n.showroom-wrapper {\n  flex: 1;\n  min-width: 0;\n}\n\n.filter-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  background-color: #1f2937;\n  color: #ffffff;\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 0.82rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n.filter-chip i {\n  font-size: 1rem;\n}\n.filter-chip:hover {\n  background-color: #dc2626;\n  transform: translateY(-1px);\n}\n@media (max-width: 768px) {\n  .filter-chip {\n    font-size: 0.74rem;\n    padding: 3px 8px;\n  }\n}\n\n.tienda .showroom {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px;\n  background-color: transparent;\n  padding: 0;\n}\n\n@media (min-width: 1440px) {\n  .tienda .showroom {\n    grid-template-columns: repeat(4, 1fr);\n    gap: 18px;\n  }\n}\n@media (max-width: 1100px) {\n  .tienda .showroom {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 14px;\n  }\n}\n@media (max-width: 900px) {\n  .tienda .showroom {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 12px;\n  }\n}\n/* Estilos de Card para Desktop */\n.showroom .card {\n  width: 100%;\n  height: 100%;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 14px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n  display: flex;\n  flex-direction: column;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n.showroom .card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);\n}\n.showroom .card .img-container {\n  position: relative;\n  width: 100%;\n  height: 200px;\n  padding: 12px;\n  background: #fafafa;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n.showroom .card .img-container .img-publica {\n  max-height: 100%;\n  max-width: 100%;\n  object-fit: contain;\n  transition: transform 0.25s ease;\n}\n.showroom .card .img-container:hover .img-publica {\n  transform: scale(1.04);\n}\n.showroom .card .flag-mayorista {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 58px;\n  z-index: 2;\n  pointer-events: none;\n}\n.showroom .card .body {\n  padding: 14px 12px 12px;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  justify-content: space-between;\n}\n.showroom .card .body .name {\n  min-height: 42px;\n  height: 42px;\n  margin-bottom: 6px;\n}\n.showroom .card .body .name p {\n  font-size: 0.88rem;\n  font-weight: 600;\n  line-height: 1.3;\n  color: #1f2937;\n  margin: 0;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n.showroom .card .body .price {\n  margin: 2px 0 8px;\n}\n.showroom .card .body .price .card-title {\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: #dc2626;\n  margin: 0;\n}\n.showroom .card .body .options {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 8px;\n  border-top: 1px solid #f3f4f6;\n}\n.showroom .card .body .options .vermas {\n  font-size: 0.84rem;\n  font-weight: 600;\n  color: #2563eb;\n  margin: 0;\n}\n.showroom .card .body .options .vermas:hover {\n  text-decoration: underline;\n}\n.showroom .card .body .options .icon {\n  font-size: 1.45rem;\n  color: #1f2937;\n  cursor: pointer;\n  transition: color 0.15s ease, transform 0.15s ease;\n}\n.showroom .card .body .options .icon:hover {\n  color: #dc2626;\n  transform: scale(1.15);\n}\n.showroom .card .body .options .icon.text-muted {\n  color: #9ca3af !important;\n  cursor: not-allowed;\n}\n.showroom .card .body .options .icon.text-muted:hover {\n  transform: none;\n}\n\n/* Mobile Overrides */\n@media (max-width: 640px) {\n  .tienda {\n    padding: 10px 0 24px;\n  }\n  .tienda-header-bar {\n    padding: 6px 10px 4px;\n  }\n  .tienda-content {\n    padding: 0 10px;\n    gap: 10px;\n  }\n  .tienda .showroom {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 10px;\n    width: 100%;\n  }\n  .showroom .card {\n    border-radius: 12px;\n  }\n  .showroom .card .img-container {\n    height: 160px;\n    padding: 8px;\n  }\n  .showroom .card .flag-mayorista {\n    height: 52px;\n  }\n  .showroom .card .body {\n    padding: 10px 8px 8px;\n  }\n  .showroom .card .body .name {\n    height: 36px;\n    min-height: 36px;\n    margin-bottom: 4px;\n  }\n  .showroom .card .body .name p {\n    font-size: 0.82rem;\n    line-height: 1.25;\n  }\n  .showroom .card .body .price {\n    margin: 2px 0 6px;\n  }\n  .showroom .card .body .price .card-title {\n    font-size: 1.02rem;\n  }\n  .showroom .card .body .options {\n    padding-top: 4px;\n  }\n  .showroom .card .body .options .vermas {\n    font-size: 0.78rem;\n  }\n  .showroom .card .body .options .icon {\n    font-size: 1.35rem;\n  }\n}\n.empty-state {\n  background-color: #ffffff;\n  border-radius: 16px;\n  padding: 3.5rem 1.5rem;\n  border: 1px dashed #d1d5db;\n}\n@media (max-width: 768px) {\n  .empty-state {\n    padding: 2rem 1rem;\n  }\n}\n\n.cart-modal {\n  position: fixed;\n  z-index: 1050;\n  top: 130px;\n  right: 25px;\n  animation: slideInRight 0.3s ease-out;\n}\n@media (max-width: 768px) {\n  .cart-modal {\n    top: 90px;\n    right: 12px;\n    left: 12px;\n  }\n}\n.cart-modal .alert {\n  border-radius: 12px;\n  font-weight: 500;\n}\n\n@keyframes slideInRight {\n  from {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n.pointer {\n  cursor: pointer;\n}\n\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 44px;\n  height: 22px;\n}\n\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #d1d5db;\n  transition: 0.3s;\n  border-radius: 22px;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 16px;\n  width: 16px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  transition: 0.3s;\n  border-radius: 50%;\n}\n\ninput:checked + .slider {\n  background-color: #16a34a;\n}\n\ninput:checked + .slider:before {\n  transform: translateX(22px);\n}\n\n/* ==========================================================================\n   Paginación Moderna & Responsive\n   ========================================================================== */\n.custom-pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.custom-pagination .pagination-list {\n  display: flex;\n  align-items: center;\n  list-style: none;\n  padding: 6px 8px;\n  margin: 0;\n  gap: 8px;\n  background: #ffffff;\n  border-radius: 14px;\n  border: 1px solid #e5e7eb;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n}\n@media (max-width: 576px) {\n  .custom-pagination .pagination-list {\n    gap: 6px;\n    padding: 4px 6px;\n    border-radius: 12px;\n  }\n}\n.custom-pagination .pagination-item {\n  display: flex;\n  align-items: center;\n}\n.custom-pagination .pagination-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 38px;\n  padding: 0 16px;\n  font-size: 0.88rem;\n  font-weight: 600;\n  color: #374151;\n  background-color: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: all 0.2s ease-in-out;\n  user-select: none;\n}\n.custom-pagination .pagination-btn i {\n  font-size: 1.25rem;\n  line-height: 1;\n  display: inline-flex;\n  align-items: center;\n}\n.custom-pagination .pagination-btn:hover:not(:disabled) {\n  background-color: #dc2626;\n  border-color: #dc2626;\n  color: #ffffff;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 10px rgba(220, 38, 38, 0.2);\n}\n.custom-pagination .pagination-btn:active:not(:disabled) {\n  transform: translateY(0);\n  box-shadow: 0 1px 3px rgba(220, 38, 38, 0.2);\n}\n.custom-pagination .pagination-btn:focus-visible {\n  outline: 2px solid #dc2626;\n  outline-offset: 2px;\n}\n.custom-pagination .pagination-btn:disabled {\n  background-color: #f3f4f6;\n  border-color: #e5e7eb;\n  color: #9ca3af;\n  cursor: not-allowed;\n  opacity: 0.55;\n  box-shadow: none;\n  pointer-events: none;\n}\n@media (max-width: 576px) {\n  .custom-pagination .pagination-btn {\n    height: 36px;\n    width: 36px;\n    padding: 0;\n    border-radius: 8px;\n  }\n  .custom-pagination .pagination-btn .btn-text {\n    display: none;\n  }\n  .custom-pagination .pagination-btn i {\n    font-size: 1.35rem;\n  }\n}\n.custom-pagination .pagination-info-item {\n  display: flex;\n  align-items: center;\n}\n.custom-pagination .pagination-indicator {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  height: 38px;\n  padding: 0 12px;\n  font-size: 0.88rem;\n  font-weight: 500;\n  color: #4b5563;\n  white-space: nowrap;\n}\n.custom-pagination .pagination-indicator .indicator-text {\n  color: #6b7280;\n}\n.custom-pagination .pagination-indicator .indicator-current {\n  font-weight: 700;\n  color: #dc2626;\n}\n.custom-pagination .pagination-indicator .indicator-separator {\n  color: #9ca3af;\n}\n.custom-pagination .pagination-indicator .indicator-total {\n  font-weight: 600;\n  color: #1f2937;\n}\n@media (max-width: 576px) {\n  .custom-pagination .pagination-indicator {\n    height: 36px;\n    padding: 0 6px;\n    font-size: 0.82rem;\n  }\n  .custom-pagination .pagination-indicator .indicator-text {\n    display: none;\n  }\n}",".tienda {\n  background-color: #f4f4f4;\n  min-height: calc(100vh - 120px);\n  padding: 20px 0 40px;\n}\n\n.tienda-header-bar {\n  background-color: #f4f4f4;\n  padding: 6px 20px 10px;\n  max-width: 1440px;\n  margin: 0 auto;\n\n  @media (max-width: 768px) {\n    padding: 4px 12px 6px;\n  }\n}\n\n.breadcrumb-nav {\n  padding: 2px 0 6px;\n\n  .breadcrumb-item {\n    font-size: 0.88rem;\n    color: #4b5563;\n\n    &.active {\n      color: #111827;\n      font-weight: 600;\n    }\n\n    @media (max-width: 768px) {\n      font-size: 0.78rem;\n    }\n  }\n}\n\n.sort-box {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  .sort-label {\n    font-size: 0.88rem;\n    color: #4b5563;\n    font-weight: 600;\n    margin: 0;\n    white-space: nowrap;\n\n    @media (max-width: 768px) {\n      font-size: 0.78rem;\n    }\n  }\n\n  .sort-select {\n    height: 40px;\n    width: 155px;\n    border-radius: 10px;\n    border: 1px solid #d1d5db;\n    background-color: #ffffff;\n    font-size: 0.86rem;\n    font-weight: 500;\n    cursor: pointer;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n\n    &:focus {\n      border-color: #dc2626;\n      box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.12);\n    }\n\n    @media (max-width: 768px) {\n      height: 36px;\n      width: 135px;\n      font-size: 0.78rem;\n      padding: 4px 8px;\n    }\n  }\n}\n\n.tienda-content {\n  display: flex;\n  flex-direction: row;\n  max-width: 1440px;\n  margin: 0 auto;\n  padding: 0 20px;\n  gap: 16px;\n\n  @media (max-width: 900px) {\n    flex-direction: column;\n    padding: 0 12px;\n    gap: 12px;\n  }\n}\n\n.filtro {\n  width: 250px;\n  min-width: 230px;\n  flex-shrink: 0;\n\n  @media (max-width: 900px) {\n    width: 100%;\n    min-width: 100%;\n  }\n\n  .accordion-item {\n    border-radius: 12px;\n    overflow: hidden;\n    border: 1px solid #e5e7eb;\n    background: #ffffff;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.03);\n  }\n\n  .btn-filtro {\n    background-color: #ffffff;\n    border: none;\n    padding: 10px 16px;\n    font-weight: 600;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    color: #1f2937;\n\n    &:focus {\n      box-shadow: none;\n    }\n\n    @media (max-width: 768px) {\n      padding: 8px 12px;\n      font-size: 0.88rem;\n    }\n  }\n\n  .btn-limpiar-filtros {\n    width: auto;\n    min-width: 130px;\n    max-width: 170px;\n    padding: 6px 14px;\n    font-size: 0.86rem;\n    border-radius: 8px;\n    margin: 0 auto;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .accordion-content {\n    padding: 8px 16px 16px;\n    width: 100%;\n\n    @media (max-width: 768px) {\n      padding: 6px 12px 12px;\n    }\n  }\n\n  .form-select {\n    border-radius: 8px;\n    border: 1px solid #d1d5db;\n    font-size: 0.88rem;\n    padding: 8px 12px;\n\n    &:focus {\n      border-color: #dc2626;\n      box-shadow: 0 0 0 2px rgba(220, 38, 38, 0.12);\n    }\n\n    @media (max-width: 768px) {\n      font-size: 0.82rem;\n      padding: 6px 10px;\n    }\n  }\n}\n\n.showroom-wrapper {\n  flex: 1;\n  min-width: 0;\n}\n\n.filter-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  background-color: #1f2937;\n  color: #ffffff;\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 0.82rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s ease;\n\n  i {\n    font-size: 1rem;\n  }\n\n  &:hover {\n    background-color: #dc2626;\n    transform: translateY(-1px);\n  }\n\n  @media (max-width: 768px) {\n    font-size: 0.74rem;\n    padding: 3px 8px;\n  }\n}\n\n.tienda .showroom {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px;\n  background-color: transparent;\n  padding: 0;\n}\n\n@media (min-width: 1440px) {\n  .tienda .showroom {\n    grid-template-columns: repeat(4, 1fr);\n    gap: 18px;\n  }\n}\n\n@media (max-width: 1100px) {\n  .tienda .showroom {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 14px;\n  }\n}\n\n@media (max-width: 900px) {\n  .tienda .showroom {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 12px;\n  }\n}\n\n/* Estilos de Card para Desktop */\n.showroom .card {\n  width: 100%;\n  height: 100%;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 14px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n  display: flex;\n  flex-direction: column;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n\n  &:hover {\n    transform: translateY(-3px);\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);\n  }\n\n  .img-container {\n    position: relative;\n    width: 100%;\n    height: 200px;\n    padding: 12px;\n    background: #fafafa;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n\n    .img-publica {\n      max-height: 100%;\n      max-width: 100%;\n      object-fit: contain;\n      transition: transform 0.25s ease;\n    }\n\n    &:hover .img-publica {\n      transform: scale(1.04);\n    }\n  }\n\n  .flag-mayorista {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 58px;\n    z-index: 2;\n    pointer-events: none;\n  }\n\n  .body {\n    padding: 14px 12px 12px;\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    justify-content: space-between;\n\n    .name {\n      min-height: 42px;\n      height: 42px;\n      margin-bottom: 6px;\n\n      p {\n        font-size: 0.88rem;\n        font-weight: 600;\n        line-height: 1.3;\n        color: #1f2937;\n        margin: 0;\n        display: -webkit-box;\n        -webkit-line-clamp: 2;\n        -webkit-box-orient: vertical;\n        overflow: hidden;\n      }\n    }\n\n    .price {\n      margin: 2px 0 8px;\n\n      .card-title {\n        font-size: 1.15rem;\n        font-weight: 700;\n        color: #dc2626;\n        margin: 0;\n      }\n    }\n\n    .options {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      padding-top: 8px;\n      border-top: 1px solid #f3f4f6;\n\n      .vermas {\n        font-size: 0.84rem;\n        font-weight: 600;\n        color: #2563eb;\n        margin: 0;\n\n        &:hover {\n          text-decoration: underline;\n        }\n      }\n\n      .icon {\n        font-size: 1.45rem;\n        color: #1f2937;\n        cursor: pointer;\n        transition: color 0.15s ease, transform 0.15s ease;\n\n        &:hover {\n          color: #dc2626;\n          transform: scale(1.15);\n        }\n\n        &.text-muted {\n          color: #9ca3af !important;\n          cursor: not-allowed;\n          &:hover {\n            transform: none;\n          }\n        }\n      }\n    }\n  }\n}\n\n/* Mobile Overrides */\n@media (max-width: 640px) {\n  .tienda {\n    padding: 10px 0 24px;\n  }\n\n  .tienda-header-bar {\n    padding: 6px 10px 4px;\n  }\n\n  .tienda-content {\n    padding: 0 10px;\n    gap: 10px;\n  }\n\n  .tienda .showroom {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 10px;\n    width: 100%;\n  }\n\n  .showroom .card {\n    border-radius: 12px;\n\n    .img-container {\n      height: 160px;\n      padding: 8px;\n    }\n\n    .flag-mayorista {\n      height: 52px;\n    }\n\n    .body {\n      padding: 10px 8px 8px;\n\n      .name {\n        height: 36px;\n        min-height: 36px;\n        margin-bottom: 4px;\n\n        p {\n          font-size: 0.82rem;\n          line-height: 1.25;\n        }\n      }\n\n      .price {\n        margin: 2px 0 6px;\n\n        .card-title {\n          font-size: 1.02rem;\n        }\n      }\n\n      .options {\n        padding-top: 4px;\n\n        .vermas {\n          font-size: 0.78rem;\n        }\n\n        .icon {\n          font-size: 1.35rem;\n        }\n      }\n    }\n  }\n}\n\n.empty-state {\n  background-color: #ffffff;\n  border-radius: 16px;\n  padding: 3.5rem 1.5rem;\n  border: 1px dashed #d1d5db;\n\n  @media (max-width: 768px) {\n    padding: 2rem 1rem;\n  }\n}\n\n.cart-modal {\n  position: fixed;\n  z-index: 1050;\n  top: 130px;\n  right: 25px;\n  animation: slideInRight 0.3s ease-out;\n\n  @media (max-width: 768px) {\n    top: 90px;\n    right: 12px;\n    left: 12px;\n  }\n\n  .alert {\n    border-radius: 12px;\n    font-weight: 500;\n  }\n}\n\n@keyframes slideInRight {\n  from {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n.pointer {\n  cursor: pointer;\n}\n\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 44px;\n  height: 22px;\n}\n\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #d1d5db;\n  transition: 0.3s;\n  border-radius: 22px;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 16px;\n  width: 16px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  transition: 0.3s;\n  border-radius: 50%;\n}\n\ninput:checked + .slider {\n  background-color: #16a34a;\n}\n\ninput:checked + .slider:before {\n  transform: translateX(22px);\n}\n\n/* ==========================================================================\n   Paginación Moderna & Responsive\n   ========================================================================== */\n.custom-pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  .pagination-list {\n    display: flex;\n    align-items: center;\n    list-style: none;\n    padding: 6px 8px;\n    margin: 0;\n    gap: 8px;\n    background: #ffffff;\n    border-radius: 14px;\n    border: 1px solid #e5e7eb;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n\n    @media (max-width: 576px) {\n      gap: 6px;\n      padding: 4px 6px;\n      border-radius: 12px;\n    }\n  }\n\n  .pagination-item {\n    display: flex;\n    align-items: center;\n  }\n\n  .pagination-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    height: 38px;\n    padding: 0 16px;\n    font-size: 0.88rem;\n    font-weight: 600;\n    color: #374151;\n    background-color: #f9fafb;\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n    cursor: pointer;\n    white-space: nowrap;\n    transition: all 0.2s ease-in-out;\n    user-select: none;\n\n    i {\n      font-size: 1.25rem;\n      line-height: 1;\n      display: inline-flex;\n      align-items: center;\n    }\n\n    &:hover:not(:disabled) {\n      background-color: #dc2626;\n      border-color: #dc2626;\n      color: #ffffff;\n      transform: translateY(-1px);\n      box-shadow: 0 4px 10px rgba(220, 38, 38, 0.2);\n    }\n\n    &:active:not(:disabled) {\n      transform: translateY(0);\n      box-shadow: 0 1px 3px rgba(220, 38, 38, 0.2);\n    }\n\n    &:focus-visible {\n      outline: 2px solid #dc2626;\n      outline-offset: 2px;\n    }\n\n    &:disabled {\n      background-color: #f3f4f6;\n      border-color: #e5e7eb;\n      color: #9ca3af;\n      cursor: not-allowed;\n      opacity: 0.55;\n      box-shadow: none;\n      pointer-events: none;\n    }\n\n    @media (max-width: 576px) {\n      height: 36px;\n      width: 36px;\n      padding: 0;\n      border-radius: 8px;\n\n      .btn-text {\n        display: none;\n      }\n\n      i {\n        font-size: 1.35rem;\n      }\n    }\n  }\n\n  .pagination-info-item {\n    display: flex;\n    align-items: center;\n  }\n\n  .pagination-indicator {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n    height: 38px;\n    padding: 0 12px;\n    font-size: 0.88rem;\n    font-weight: 500;\n    color: #4b5563;\n    white-space: nowrap;\n\n    .indicator-text {\n      color: #6b7280;\n    }\n\n    .indicator-current {\n      font-weight: 700;\n      color: #dc2626;\n    }\n\n    .indicator-separator {\n      color: #9ca3af;\n    }\n\n    .indicator-total {\n      font-weight: 600;\n      color: #1f2937;\n    }\n\n    @media (max-width: 576px) {\n      height: 36px;\n      padding: 0 6px;\n      font-size: 0.82rem;\n\n      .indicator-text {\n        display: none;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
